export default class {
    static STATUS_ACTIVE = 1;
    static STATUS_DISABLED = 2;
}